import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

//import { createRoute, localSave, localRead } from "@/libs/util";

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import { 
  formatMoney
} from "@/libs/tools";

Vue.config.productionTip = false;

const moment = require('moment')
require('moment/locale/mn')

Vue.use(require('vue-moment'), {
  moment
})

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage);

import lang from 'element-ui/lib/locale/lang/mn'
import locale from 'element-ui/lib/locale'
locale.use(lang)

import './assets/css/dashforge.css';
var _ = require('lodash');

Vue.filter('formatMoney', function (n, c, d, t) {
  return formatMoney(n, c, d, t);
});


import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCedvV7Iaudm_3l3zozOR_fe_bVfNkXua4',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing,visualization'
  },
  installComponents: true
})

new Vue({
  store,
  vuetify,
  _,
  router,
 
  created(){    
    //store.dispatch('handleRoutes', {router})   
  },
  render: h => h(App)
}).$mount("#app");
